// This file is generated, don't edit manually!
i18n = typeof i18n == 'undefined' ? {} : i18n;
i18n.langs = {};
i18n.langs.cs = {
	"Agent je přihlášen ve {n} frontách": [
		"Agent je přihlášen v {n} frontě",
		"Agent je přihlášen ve {n} frontách",
		"Agent je přihlášen v {n} frontách"
	],
	"Importováno {n} záznamů": [
		"Importován {n} záznam",
		"Importovány {n} záznamy",
		"Importováno {n} záznamů"
	],
	"Service level": "Úroveň služby",
	"Vybráno *{n} adresářů*": [
		"Vybrán *{n} adresář*",
		"Vybrány *{n} adresáře*",
		"Vybráno *{n} adresářů*"
	],
	"Vybráno *{n} front*": [
		"Vybrána *{n} fronta*",
		"Vybrány *{n} fronty*",
		"Vybráno *{n} front*"
	],
	"Vybráno *{n} komunikačních kanálů*": [
		"",
		"",
		""
	],
	"Vybráno *{n} linek*": [
		"Vybrána *{n} linka*",
		"Vybrány *{n} linky*",
		"Vybráno *{n} linek*"
	],
	"Vybráno *{n} pauz*": [
		"Vybrána *{n} pauza*",
		"Vybrány *{n} pauzy*",
		"Vybráno *{n} pauz*"
	],
	"Vybráno *{n} položek*": [
		"Vybrána *{n} položka*",
		"Vybrány *{n} položky*",
		"Vybráno *{n} položek*"
	],
	"Vybráno *{n} uživatelů*": [
		"Vybrán *{n} uživatel*",
		"Vybráni *{n} uživatelé*",
		"Vybráno *{n} uživatelů*"
	],
	"Vybráno *{n} záložek*": [
		"Vybrána *{n} záožka*",
		"Vybrány *{n} záožky*",
		"Vybráno *{n} záložek*"
	],
	"Vybráno *{n} záznamníků*": [
		"Vybrána *{n} záznamník*",
		"Vybrána *{n} záznamníky*",
		"Vybrána *{n} záznamníků*"
	],
	"Vybráno *{n} časových podmínek*": [
		"",
		"",
		""
	],
	"Vybráno *{n} šablon*": [
		"Vybrána *{n} šablona*",
		"Vybrány *{n} šablony*",
		"Vybráno *{n} šablon*"
	],
	"{n} záznamů se importovat nepodařilo": [
		"{n} záznam se importovat nepodařilo",
		"{n} záznamy se importovat nepodařilo",
		"{n} záznamů se importovat nepodařilo"
	],
	"__plural": function(n) { return (n==1) ? 0 : ((n>=2 && n<=4) ? 1 : 2); },
	"__nplurals": 3
};
i18n.langs.en = {
	"(wav, ogg/vorbis, mp3, ...)": "(wav, ogg/vorbis, mp3, ...)",
	"+420 261 303 303": "+420 261 303 303",
	"<{s}s": "<{s}s",
	">{s}s": "<{s}s",
	"ACL": "ACL",
	"ACL hovoru": "Call ACL",
	"AP": "AP",
	"API Malfini pluginu": "Malfini plugin API",
	"API Tester": "API Tester",
	"API pluginu pro Staropramen": "Staropramen plugin API",
	"API přístupy": "API access",
	"API výrobce telefonu": "Phone vendor API",
	"API ČZU pluginu": "API of ČZU plugin",
	"Aby jste mohli pokračovat musíte souhlasit s podmínkami": "You need to agree to continue",
	"Address": "Address",
	"Administrace": "Administration",
	"Administrace PBX": "PBX administration",
	"Administrace ústředny": "PBX administration",
	"Administrační přehled": "Administration overview",
	"Administrátor ústředny": "PBX administrator",
	"Administrátorská příručka": "Administartor guide",
	"Adresář": "Directory",
	"Adresář kontaktů": "Contact directory",
	"Adresáře": "Directories",
	"Adresáře kontaktů": "Contact directories",
	"Adresáře můžete přidat výběrem z pravého sloupce": "You can add directories by selecting them from the right column",
	"Adresáře ve skupině": "Directories in a group",
	"Agency": "Agency",
	"Agency stuff": "Agency stuff",
	"Agent": "Agent",
	"Agent je považovaný jako volný vždy, když má aktivovanou externí linku.": "Agent is considered free whenever they have external line is activated.",
	"Agent je přihlášen na externí lince": "Agent is logged into an external extension",
	"Agent je přihlášen v jedné frontě": "Agent is logged into one queue",
	"Agent je přihlášen ve frontách, ale nemá registrované žádné zařízení!": "Agent is logged into queues, but does not have any devices registered!",
	"Agent je přihlášen ve {n} frontách": [
		"Agent is logged into {n} queue",
		"Agent is logged into {n} queues"
	],
	"Agent může na záložce Agenti přihlašovat a odhlašovat ostatní agenty z a do front": "Agent can manage other agent's membership in queues in the Agent panel",
	"Agent není přihlášen ani v jedné frontě!": "Agent is not logged into any queue!",
	"Agent není přihlášen v žádné frontě": "Agent is not logged into any queue",
	"Agent panel": "Agent panel",
	"Agent vidí jen své nahrávky": "An agent sees only their own recordings",
	"Agenti": "Agents",
	"Agenti se mohou přihlásit/odhlásit jen do všech front": "Agents can join/leave only all queues at once",
	"Agentská": "Agent",
	"Agentské pracoviště kontaktního centra": "Agent contact center",
	"Agentů v pauze": "Paused agents",
	"Akce": "Action",
	"Aktivita": "Activity",
	"Aktivita přehrání záznamu ze záznamníku": "Activity of recordings machine recording playback",
	"Aktivní": "Active",
	"Aktivní a čekající hovory": "Active and pending calls",
	"Aktivní hovory": "Active calls",
	"Aktivní záložky": "Active tabs",
	"Aktivovat": "Activate",
	"Aktivovat automatické opuštění": "Activate automatic exit",
	"Aktivovat kampaň": "Activate campaign",
	"Aktuálně neprobíhá žádný hovor": "There is no call ongoing",
	"All-in-one komunikační platforma pro péči o zákazníky": "All-in-one communication platform for customer relations",
	"Ano": "Yes",
	"Ano, uzavřít i callback": "Yes, and close callback",
	"Aplikace": "Application",
	"Aplikace byla aktualizována na verzi {version}, je třeba obnovit stránku pro dokončení aktualizace.": "The application has been updated to version {version}, you need to refresh the page to complete the update.",
	"Aplikace není nyní dostupná (server se restartuje, nebo selhal)": "Application is currently not available (the server failed or is restarting)",
	"Aplikace spojovatelka": "Switchboard application",
	"Aplikovat konfiguraci": "Apply configuration",
	"Archiv": "Archive",
	"Archivované": "Archived",
	"Archivovat": "Archive",
	"Archivovat kampaň": "Archive campaign",
	"Audio je nutné nahrát": "You must upload audio file",
	"Auto pauza [s]": "Autopause [s]",
	"Automaticky otevřít kartu hovoru při začátku zvonění.": "Open a call info card automatically for incoming calls on the first ring.",
	"Automaticky přepnout na novou kartu hovoru.": "Switch to the call info card automatically.",
	"Automaticky uzavřít kartu hovoru při nevyzvednutí hovoru.": "Close the card automatically when the call is not answered.",
	"Automatické opuštění": "Automatic exit",
	"Automatické otevření karty hovoru": "Automatic call info card activation",
	"Automatické vyzvednutí": "Autoanswer",
	"Automatický": "Automatic",
	"Autopauza": "Autopause",
	"BC4 Kontaktní centrum": "BC4 Contact center",
	"Bez editace": "Editing disabled",
	"Bez filtru": "No filter",
	"Bez fronty": "No queue",
	"Bez povolených notifikací si nemusíte všimnout hovorů pokud máte okno na pozadí. Notifikace si můžete v budoucnu zapnout ručně.": "Without desktop notifications, you may miss calls when your browser window is in background. You can still enable notifications again in the future in your browser.",
	"Bez projektu": "No project",
	"Birth date": "Birth date",
	"Bugreporty": "Bug reports",
	"BusinessCom a.s.": "BusinessCom a.s.",
	"Během importu nastaly nějaké chyby": "Some errors occurred during import",
	"Běžné vyzvánění": "Normal ringing",
	"CDR": "CDR",
	"CDR Asterisk": "Asterisk CDR",
	"CDR QoS": "CDR QoS",
	"Call ID": "Call ID",
	"Call flow": "Call flow",
	"Call flow nenalezeno": "Call flow not found",
	"Callback": "Callback",
	"Callback - Graf uzavření případů": "Callback - Closed cases graph",
	"Callflow": "Callflow",
	"Celkem": "Total",
	"Celkem\nhovorů": "Total\ncalls",
	"Celkem In": "Total In",
	"Celkem Out": "Total Out",
	"Celkem callbacků": "Total callbacks",
	"Celkem hovorů": "Total calls",
	"Celkem příchozích": "Total incomming",
	"Celkem v pauze": "Total paused",
	"Celkem zmeškaných hovorů": "Total missed calls",
	"Celkem zmeškaných případů": "Total missed cases",
	"Celkem {time}": "Total {time}",
	"Celková\ndoba hovorů": "Total duration\nof calls",
	"Celková doba hovorů": "Total duration of calls",
	"Celková délka\nhovorů": "Total duration\nof calls",
	"Celková délka hovorů": "Total duration of calls",
	"Celkový počet čísel": "Total number of numbers",
	"Chcete se z těchto front odhlásit nebo v nich po odhlášení z aplikace zůstat?": "Do you want to log out of these queues or stay in them after logging out of the app?",
	"Chcete uzavřít i callback?": "Do you want to close callback, too?",
	"Chlívečkový": "Table",
	"Chování": "Behavior",
	"Chyba": "Error",
	"Chyba na řádce {n}: Zpráva je moc dlouhá.": "Error on line {n}: The message is too long.",
	"Chyba na řádce {n}: Žádné číslo.": "Error on line {n}: Missing number.",
	"Chyba serveru": "Server error",
	"Chyba: ": "Error: ",
	"Chybná e-mailová adresa": "Invalid e-mail address",
	"Chybná hodnota": "Invalid value",
	"Chybné číslo": "Wrong number",
	"Chybný formát datumu a času. Použijte d.m.r h:m nebo m/d/r h:m": "Invalid date/time format. Use d.m.y H:M, or m/d/y. H:M",
	"Chybný formát datumu. Použijte d.m.r nebo m/d/r": "Invalid date format. Use d.m.y, or m/d/y",
	"Chybný formát čísla": "Incorrect number format",
	"Cíl": "Target",
	"Cílová fronta": "Destination queue",
	"Cílová linka": "Destination extension",
	"Cílové call flow": "Destination call flow",
	"Data celé skupiny - všechny role vidí data celé skupiny": "Data for the whole group - all roles can view data for the whole group",
	"Data nejsou načtena": "Data are not loaded",
	"Data se načítají...": "Loading...",
	"Datové spojení bylo přerušeno": "Data connection has been dropped",
	"Datum": "Date",
	"Datum a čas": "Date and time",
	"Deaktivovat": "Deactivate",
	"Deaktivovat kampaň": "Deactivate campaign",
	"Debugovací panel": "Debug panel",
	"Deep Backend": "Deep backend",
	"Detail": "Detail",
	"Detail kampaně": "Campaign detail",
	"Detaily": "Details",
	"Detaily hovoru": "Call detail",
	"Detekována smyčka přesměrování skrze {path}": "Redirect loop detected via {path}",
	"Dialer": "Dialer",
	"Dnes": "Today",
	"Dny v týdnu": "Week days",
	"Do": "To",
	"Doba trvání pauzy (s)": "Pause duration (s)",
	"Doba ve frontě": "Queue time",
	"Dobrušská 1794/1\n147 00 Praha 4": "Dobrušská 1794/1\n147 00 Praha 4",
	"Docházka": "Attendance",
	"Dodatečné číslo volajícího": "Additional caller name",
	"Dokončeno": "Completed",
	"Dokončenost": "Finished calls",
	"Dokončit přepojení": "Finish redirect",
	"Dokončit registraci": "Complete registration",
	"Dokumentace": "Documentation",
	"Dokumentace API": "API documentation",
	"Dokumentace nebyla nenalezena.": "Documentation was not found.",
	"Dokumentace pro aplikaci\nBC4 Kontaktní centrum": "BC4 Contact center\nuser documentation",
	"Dostupné adresáře": "Available directories",
	"Dostupné fronty": "Available queues",
	"Dostupné linky": "Available extensions",
	"Dostupné pauzy": "Available pauses",
	"Dostupné záložky": "Available tabs",
	"Dostupné záznamníky": "Available mailboxes",
	"Dostupný": "Available",
	"Dovolané": "Picked up",
	"Dovolaných In": "Answered In",
	"Dovolaných Out": "Answered Out",
	"Druh": "Kind",
	"Duplicitní": "Duplicit",
	"Dát do pauzy agenta po skončení hovoru": "Pause agent after completing a call",
	"Dát do pauzy agenta, který hovor nepřijal": "Pause agent who did not accept the call",
	"Délka hovoru": "Call duration",
	"Délka pauzy [s]": "Pause duration [s]",
	"Délka pauzy v sekundách": "Pause duration in seconds",
	"Délka vyzvánění": "Ringing duration",
	"Délka záznamu": "Recording duration",
	"Děkujeme za hlášení": "Thank you for the report",
	"E-mail": "Email",
	"Editace": "Editing",
	"Edituje agent": "Agents can edit",
	"Edituje supervizor": "Supervisors can edit",
	"Export": "Export",
	"Export kontaktů": "Export contacts",
	"Exportovat CSV pro Mitel": "Export CSV for Mitel",
	"Exportovat XLSX": "Export XLSX",
	"Exportovat XML pro Htek": "Export XML for Htek",
	"Exportovat XML pro Yealink": "Export XML for Yealink",
	"Ext.": "Ext.",
	"Externí linka": "External extension",
	"Firma": "Company",
	"campaign-case-export|Firma": "Company",
	"Firma posledního volaného": "Last callee's company name",
	"Firma volajícího": "Caller's company name",
	"Firma volaného": "Callee's company name",
	"Followme": "Followme",
	"Followme (přesměrování)": "Followme (redirect)",
	"Freeseating": "Freeseating",
	"Freshdesk": "Freshdesk",
	"Fronta": "Queue",
	"Fronta skrze kterou volat": "Queue prefix to use",
	"Fronta {queue} nemá přiřazenu skupinu kategorií.": "The queue {queue} does not have a category group assigned.",
	"Frontové požadavky": "Queue requests",
	"Fronty": "Queues",
	"Fronty můžete přidat výběrem z pravého sloupce": "You can add queues by selecting them from the right column",
	"Fronty ve skupině": "Queues in a group",
	"Generovat": "Generate",
	"Generovat hlášku": "Generate a message",
	"Graf uzavření případů": "Closed cases graph",
	"Graf úspěšnosti": "Success graph",
	"HW": "HW",
	"Headsety": "Headsets",
	"Hesla se neshodují": "Passwords do not match",
	"Heslo": "Password",
	"Heslo musí musí být dlouhé alespoň 12 znaků.": "Password needs to be at least 12 characters long.",
	"Heslo změněno": "Password changed",
	"Historie": "History",
	"Historie front": "Queues history",
	"Historie hovorů ústředny": "PBX call history",
	"Historie hovorů ústředny Mx-One": "Call History PBX Mx-One",
	"Historie volání": "Call history",
	"Historie čísel": "Phone number history",
	"Historie čísla": "Caller history",
	"Hlas": "Voice",
	"Hlasitost": "Volume",
	"Hlavní kategorie": "Main category",
	"Hledat": "Search",
	"Hledat agenta nebo linku": "Search for agent or extension",
	"Hledat jméno nebo email": "Search for name or email",
	"Hledat jméno, firmu, linku": "Search for name, company, or phone",
	"Hledat jméno, firmu, telefon": "Search name, company, phone",
	"Hledat kampaň": "Search campaign",
	"Hledat kontakt": "Search for contact",
	"Hledat linku": "Search extensions",
	"Hledat název": "Search name",
	"Hledat název nebo číslo": "Search for name or number",
	"Hledat název nebo číslo fronty": "Search for name or queue number",
	"Hledat záložku": "Find tab",
	"Hledat záznamník": "Find mailbox",
	"Hláška": "Sound message",
	"Hláška s tónovou volbou": "Sound message with DTMF menu",
	"Hlášky": "Sounds",
	"Hlášky a zvuky": "Sounds and messages",
	"Hodnota je příliš nízká": "Value is too low",
	"Hodnota je příliš vysoká": "Value is too high",
	"Hostitel": "Host",
	"Hotel": "Hotel",
	"Hotovo": "Done",
	"Hovor": "Call",
	"Hovor je přesměrováván, prosím vyčkejte...": "The call is being transfered, please wait...",
	"Hovor nebyl nalezen, nebo k němu nemáte přístup": "The call you are trying to view was not found, or you do not have access to it",
	"Hovor neprobíhá v tomto okně prohlížeče.": "The call is not proceeding in this browser window.",
	"Hovor odmítnut": "Call rejected",
	"Hovor přesměrován": "Call redirected",
	"Hovor ukončen": "Call ended",
	"Hovor vypršel, protože nebyl vyzvednut včas": "Call expired because it was not answered on time",
	"Hovor začal": "Call started",
	"Hovory": "Calls",
	"Hovoří": "Speaking",
	"Hovoří v jiné frontě": "Speaking in other queue",
	"Hovoří v této frontě": "Speaking in this queue",
	"Hromadné rozeslání": "Mass sending",
	"Htek": "Htek",
	"Hudba při čekání": "Music on hold",
	"ID": "ID",
	"ID hovoru": "Call ID",
	"ID klienta": "Client ID",
	"ID zařízení": "Device ID",
	"IP adresa": "IP address",
	"IP adresa klienta": "Client IP address",
	"IP adresy": "IP addresses",
	"Import": "Import",
	"Import se připravuje": "Import is being prepared",
	"Importováno {n} záznamů": [
		"",
		""
	],
	"Indikace čekání ve frontě volajícímu": "Queue waiting indication to the caller",
	"Interface connector": "Interface connector",
	"Intergrovaná historie zákazníků": "Integrated customer history",
	"Interní": "Internal",
	"Interní linka": "Internal extension",
	"Interní linka nemá nastavenou odchozí identifikaci": "Internal extension is missing outbound identification number",
	"Interní linka nemůže začínat prefixem 99": "Internal extension must not start with number 99",
	"Interní linky": "Internal extensions",
	"Interval automatického opuštění fronty (s)": "Automatic queue exit interval (s)",
	"Interval přehrávání (s)": "Playback interval (s)",
	"Interval volby dalšího agenta (s)": "Next agent selection interval (s)",
	"Intervaly": "Ranges",
	"Intervaly pro správné zobrazení stavů v Agent panelu": "Ranges for agent/call overviews state colors in Agent panel",
	"Jazyk": "Language",
	"Je li přihlášený na libovolném zařízení (v agent panelu či HW telefonu)": "When logged in via any device (agent panel or HW phone)",
	"Je li přihlášený v agent panelu": "When logged in via agent panel",
	"Je třeba vybrat vlastníka fronty. Fronty nebyly přidány do skupiny.": "It is necessary to choose a queue owner. Queues were not added to the group.",
	"Je třeba zadat poznámku": "You have to write a note first",
	"Jen svá data - účastník a agent vidí jen svá data, ostatní role vidí data celé skupiny": "Only personal data - regulars and agents can view only their own data, other roles can access data of the whole group",
	"Jméno": "Name",
	"campaign-case-export|Jméno": "Name",
	"Jméno kampaně": "Campaign name",
	"Jméno linky": "Extension",
	"Jméno posledního volaného": "Last callee name",
	"Jméno skupiny": "Group name",
	"Jméno volajícího": "Caller name",
	"Jméno volaného": "Callee name",
	"Jste přihlášeni v těchto forntách": "You are logged into these fronts",
	"K nahrávkám nemáte přístup": "You do not have access to the recordings",
	"K této aplikaci nemáte přístup": "You do not have access to this application",
	"Kampaň": "Campaign",
	"Kampaň byla založena. Naleznete ji v záložce \"Neaktivní.\"": "The campaign has been created. You can find it in the \"Inactive.\"",
	"Kanál": "Channel",
	"Kanály": "Channels",
	"Karta hovoru": "Call card",
	"Karta kontaktu": "Contact card",
	"Karta zákazníka": "Customer card",
	"Kategorie": "Category",
	"Kategorie 1": "Category 1",
	"Kategorie 2": "Category 2",
	"Kategorie hovorů": "Phone call categories",
	"Kategorii lze změnit jen u frontového hovoru.": "Category can be changed only on a call to a queue.",
	"Kdo ukončil hovor": "Who ended the call",
	"Když je linka obsazena": "When the line is busy",
	"Když na lince není dostupné žádné zařízení": "When there's no registered device on the line",
	"Když ve frontě není přihlášen žádný agent": "When no agent is logged into a queue",
	"Když volaný nevyzvedne hovor": "When the callee does not answer",
	"Když všichni agenti hovoří": "When all agents are busy",
	"Kompaktní zobrazení front": "Compact queues view",
	"Komprimovat nahrávky": "Compress recordings",
	"Konec hovoru": "Call end",
	"Konfigurace je v pořádku": "Configuration is valid",
	"Konfigurace obsahuje chyby, které je nutné před uložením opravit.": "Configuration contains errors that need to be fixed, before configuration can be saved.",
	"Konkrétní data": "Individual dates",
	"Konkrétní hodiny": "Individual hours",
	"Kontakt nenalezen": "Contact not found",
	"Kontakt není uložen v adresáři": "The contact is missing from the directory",
	"Kontakt odstraněn": "Contact removed",
	"Kontakt upraven": "Contact modified",
	"Kontakt vytvořen": "Contact created",
	"Kontaktní centrum": "Contact center",
	"Kontakty": "Contacts",
	"Kontakty k importu": "Contacts to import",
	"Kontrola": "Verification",
	"Kontrola nastavení ústředny": "PBX setup verification",
	"Kopírovat odkaz": "Copy link",
	"Ladění systému": "System debugging",
	"Limit velikosti obrázku je 10 MiB.": "Image size limit is 10 MiB.",
	"Limit velikosti souboru je 10MB": "Image size limit is 10 MiB",
	"Limit velikosti souboru je {size} MiB": "File size limit is {size} MiB",
	"Linka": "Extension",
	"Linka / Telefonní číslo": "Extension / Phone number",
	"Linka má nastaveno velmi slabé heslo.": "Extension has very weak password.",
	"Linka nenalezena": "Extension not found",
	"Linka sdílí heslo s jinými linkami. Sdílení hesel je nebezpečné.": "The extension shares password with other extensions. Password sharing is dangerous.",
	"Linked ID": "Linked ID",
	"Linked Id": "Linked ID",
	"Linky": "Extensions",
	"Linky můžete přidat výběrem z pravého sloupce": "You can add queues by selecting them from the right column",
	"Linky ve skupině": "Extensions in a group",
	"Log události z POST /api/debug/loopback": "Event log from POST /api/debug/loopback",
	"Logy mobilní aplikace": "Mobile application logs",
	"Lokální číslo": "Local number",
	"Loopback log": "Loopback log",
	"Lze nahrát pouze soubor do velikosti {size} MiB": "Only files up to {size} MiB can be uploaded",
	"Minulý měsíc": "Last month",
	"Minulý rok": "Last year",
	"Minulý týden": "Last week",
	"Minut": "Minutes",
	"Mluvii": "Mluvii",
	"Moje otevřené": "My open cases",
	"Moje případy": "My Cases",
	"Moje uzavřené": "My closed cases",
	"Musí být jedno až šestimítné číslo": "Must be a 1-6 digit number",
	"Musí být kratší něž 500 znaků": "Must be shorter than 500 characters",
	"Musí být telefonní číslo": "Must be a phone number",
	"Musí být veřejné číslo v mezinárodním formátu": "Must be a public service phone number in international format",
	"Musí být číslo": "Invalid number",
	"Musí být řetězec 1 - 60 znaků": "Must be a string with 1 - 60 characters",
	"Musí mít alespoň 5 znaků": "Must be at least 5 characters long",
	"Mx-One CDR": "Mx-One CDR",
	"Má pauzu": "Paused",
	"Máte podržený hovor": "You have a call on hold",
	"Máte probíhající hovor": "You have a call in progress",
	"Máte příchozí hovor": "You have an incoming call",
	"Méně": "Less",
	"Měsíční report": "Monthly report",
	"Můžete buď stáhnout soubor s kontakty do vašeho počítače, nebo zkopírovat odkaz do telefonu, pro automatickou synchronizaci kontaktů.": "You can either download the contacts file to your computer or copy the link to the your phone, for automatically sync your contacts.",
	"Na Váš e-mail Vám zašleme odkaz na stránku, kde si budete moci nastavit nové heslo.": "We will send a link to your email to a page where you can set up a new password.",
	"Nahlásit problém": "Report a problem",
	"Nahrání selhalo - neznámá chyba": "Upload failed - unknown error",
	"Nahrání selhalo - vypršel časový limit": "Upload failed - timeout expired",
	"Nahrát": "Upload",
	"Nahrát hlášku": "Upload sound message",
	"Nahrát lze jen jedno foto": "Only one photo can be uploaded",
	"Nahrát lze pouze fotografie": "Only photos can be uploaded",
	"Nahrát soubor": "Upload a file",
	"Nahrát soubor (.XLSX)": "Upload file (.XLSX)",
	"Nahrát soubor (wav, ogg/vorbis, mp3, ...)": "Upload file (wav, ogg/vorbis, mp3, ...)",
	"Nahrávat všechny hovory, které projdou touto frontou": "Record all calls via this queue",
	"Nahrávat všechny hovory, které projdou touto linkou": "Record all calls with this extensions",
	"Nahrávka nedostupná": "Upload unavailable",
	"Nahrávky": "Recordings",
	"Nahrávky přehrávat vždy na webu": "Always play recordings on the web",
	"Nahrávání hovorů": "Call recording",
	"Name": "Name",
	"Např. Vedení, Obchod, Reklamace, Servis...": "Eg. Management, Sales, Service department, ...",
	"Nastavena odchozí routa s prefixem": "Otbound prefix route used",
	"Nastavená": "Set",
	"Nastavení": "Settings",
	"Nastavení HW telefonů": "HW phones configuration",
	"Nastavení front": "Queue settings",
	"Nastavení linek": "Extensions setup",
	"Nastavení sloupců": "Table columns configuration",
	"Nastavení sítě či ústředny není optimální. Sestavení zvukového spojení hovoru může trvat delší dobu či selhávat.": "Your PBX network setup is suboptimal. Audio session establishment is slow and may fail entirely.",
	"Nastavení vyzváněcího zařízení": "Ringer device configuration",
	"Nastavení záznamníků": "Mailboxes configuration",
	"Nastavení ústředny": "PBX settings",
	"Nastavit heslo uživatele": "Set user password",
	"Nastavit nové heslo": "Set a new password",
	"Nastavit timeout": "Set timeout",
	"Nastavit vlastní heslo": "Set a custom password",
	"Načíst kartu hovoru": "Load call history",
	"Načíst novou verzi": "Load new version",
	"Načítají se data": "Loading data",
	"Načítám...": "Loading...",
	"Ne": "No",
	"Ne, neuzavírat callback": "No, don't close callback",
	"Neaktivní": "Inactive",
	"users|Neaktivní": "Suspended",
	"Nebo sem soubor přetáhněte": "Or drag the file here",
	"Nebo soubor přetáhněte sem": "Or drag the file here",
	"Nebyly nalezeny žádné kontakty": "No contacts were found",
	"Nedostupný": "Not available",
	"Nedovolané": "Not answered",
	"Nedovolaných In": "Not answered In",
	"Nedovolaných Out": "Not answered Out",
	"Neděle": "Sunday",
	"Neexistující adresář kontaktů {name}": "Contact directory does not exist: {name}",
	"Neexistující cílová fronta {num}": "Target queue does not exist {num}",
	"Neexistující cílové callflow {name}": "Target callflow does not exist {name}",
	"Neexistující linka {num}": "Extension does not exist {num}",
	"Neexistující zvuková hláška {name}": "Sound message does not exist: {name}",
	"Neexistující Časová podmínka {name}": "Time condition {name} does not exist",
	"Negativní uzavření": "Negative closure",
	"Negativní zakončení": "Negative closure",
	"Nejdelší čas\npropadlého\nhovoru": "Longest non-handled\ncall handling interval",
	"Nejpomalejší doba první reakce": "The slowest initial reaction time",
	"Nejpomalejší doba uzavření": "The slowest closure time",
	"Nejprve si vytvořte záložky pro vaše kontakty.": "Create a few tabs for your contacts first.",
	"Nejprve založte skupinu kategorií": "Create a category group first",
	"Nejrychlejší doba první reakce": "The fastest initial reaction time",
	"Nejrychlejší doba uzavření": "The fastest closure time",
	"Nejsou definovány žádné šablony": "No templates available",
	"Nejsou k dispozici žádné záznamníky": "No mailboxes are available",
	"Nejsou založeny žádné adresáře": "No directories have been created",
	"Nelze načíst konfiguraci": "Can't load configuration",
	"Nelze získat přístup k mediálním zařízením. Aplikace neběží na https, nebo je přístup vypnutý ve vašem prohlížeči.": "Failed to gain access to media devices. Application is not using https, or access to media devices is disabled in your browser.",
	"Nemá nastaveno žádné zařízení!": "Agent has no device set up!",
	"Nemáte přístup k žádným aplikacím": "You have no access to any applications",
	"Nemáte žádné call flow": "No call flow is configured, yet",
	"Nemáte žádné časové podmínky": "No time conditions are configured, yet",
	"Nenastavená": "Unconfigured",
	"Není dostupné žádné zařízení.": "No device available.",
	"Není k dispozici žádné zařízení": "No device available",
	"Není v pořádku!": "Critical!",
	"Neobsahuje nic": "No details",
	"Neomezená": "Unlimited",
	"Neošetřená výjimka": "Unhandled rejection",
	"Neplatný formát XLSX, použijte šablonu.": "Invalid XLSX format, use the template.",
	"Nepovolili jste změnu audio výstupu. Nelze změnit zařízení pro vyzvánění.": "You did not allow audio device access. It is not possible to set ringer device.",
	"Nepřihlášen v této frontě": "Not logged into this queue",
	"Nepřihlášení": "Not logged in",
	"Nepřihlášení agenti": "Logged out agents",
	"Nesmí být prázdné": "Must not be empty",
	"Neuskutečněný": "Not realized",
	"Neuzavřené případy": "Open cases",
	"Nevyzvednutí": "No answer",
	"Nevíte heslo?": "Forgot password?",
	"Nezahájeno": "Not started",
	"Nezahájené": "Not started",
	"Nezměněná": "Not changed",
	"Neznámá chyba": "Unknown error",
	"Neznámá chyba SIP": "Unknown SIP error",
	"Neznámá chyba WebRTC": "Unknown WebRTC error",
	"Neznámá chyba.": "Unknown error.",
	"Neznámé zařízení": "Unknown device",
	"Neznámý stav přihlášení do fronty": "Unknown queue membership status",
	"Neúspěch": "Failure",
	"Neúspěšné": "Failure",
	"Nic": "Nothing",
	"Nic neaktualizovat": "Don't update anything",
	"Nic nemazat": "Don't delete anything",
	"Nic nepřidávat": "Don't add anything",
	"Notes": "Notes",
	"Notifikace máte zablokovné v prohlížeči. Nejprve je musíte odblokovat.": "You have desktop notifications blocked in the browser. You need to unblock them first.",
	"Nová": "New",
	"Nová fronta": "New queue",
	"Nová hláška": "New sound",
	"Nová interní linka": "New internal extension",
	"Nová kampaň": "New campaign",
	"Nová pauza": "New pause",
	"Nová poznámka": "New note",
	"Nová skupina": "New group",
	"Nová skupina kategorií": "New category group",
	"Nová volba": "New option",
	"Nová zpráva": "New message",
	"Nová záložka": "New tab",
	"Nová časová podmínka": "New time condition",
	"Nové call flow": "New call flow",
	"Nové heslo": "New password",
	"Nové číslo": "New number",
	"Nový adresář": "New directory",
	"Nový filtr": "New filter",
	"Nový kontakt": "New contact",
	"Nový uživatel": "New user",
	"Nový záznam": "New entry",
	"Nový člen": "New member",
	"Nyní se můžete přihlásit s použitím Vašeho nového hesla.": "You can now log in using your new password.",
	"Náhrávám": "Recording",
	"Název": "Name",
	"Název aplikace": "Application name",
	"Název kampaně": "Campaign name",
	"Název nové kategorie": "New category name",
	"Některé kontakty se nepodařilo naimportovat. Seznam přeskočených kontaktů je níže. Důvodem je chybné tel. číslo či neplatná emailová adresa. Upravte XLSX soubor a import opakujte.": "Some contacts failed to import. The list of skipped contacts is below. This is due to an incorrect phone number or invalid email address. Edit XLSX file and repeat the import.",
	"O aplikaci": "About application",
	"OK": "OK",
	"Období": "Period",
	"Obecné": "Basic",
	"Obnovit": "Refresh",
	"Obnovit data": "Reload data",
	"Obsah zprávy": "Mesage content",
	"Obsahuje kategorii": "Has category assigned",
	"Obsahuje nahrávky": "Has recordings",
	"Obsahuje poznámku": "Has a note",
	"Obsazeno": "Busy",
	"Obsazení disků": "Disk utilization",
	"Obsazený": "Busy",
	"Od": "From",
	"Odchod": "Departed",
	"Odchozí": "Outgoing",
	"Odchozí filtr": "Outbound filter",
	"Odchozí filtry": "Outbound filters",
	"Odchozí identifikace": "Outbound identification",
	"Odchozí kampaně": "Outbound campaigns",
	"Odchozí prefix": "Outbound prefix",
	"Odchozí volby": "Outbound options",
	"Odebrat ze skupiny": "Remove from group",
	"Odeslaná": "Sent",
	"Odeslat": "Send",
	"Odeslat z": "Send from",
	"Odeslat znovu": "Send again",
	"Odhlásit": "Log out",
	"Odhlásit z front": "Log out of queues",
	"Odhlásit ze všech front": "Logout from all queues",
	"campaign-case-export|Odkaz": "URL",
	"Odkaz byl zaslán": "Link has been sent",
	"Odkaz zkopírován do schránky": "The link was copied to the clipboard",
	"Odložené a zaparkované hovory": "Held and parked calls",
	"Odložený": "In hold",
	"Odložit hovor": "Hold call",
	"Odmítnout": "Reject",
	"Odmítnout hovor": "Reject call",
	"Odmítnutý": "Rejected",
	"Odpojeno": "Disconnected",
	"Odposlech není možný.": "Monitoring is not possible.",
	"Odpovědět": "Reply",
	"Odstranit": "Remove",
	"Odstranit audio": "Remove audio",
	"Odstranit časový rozsah": "Remove time range",
	"Office panel": "Office panel",
	"Offline": "Offline",
	"Ohlašovat volajícímu pořadí ve frontě": "Announce queue position to the caller",
	"Omezená historie fronty": "Limited queues history",
	"Online": "Online",
	"Operátorů\nna příjmu": "Agents\navailable",
	"Oportunistické SRTP": "Opportunistic SRTP",
	"Opravdu chcete smazat DTMF volbu {code}?": "Do you really want to delete DTMF menu item {code}?",
	"Opravdu chcete smazat adresář \"{name}\"?": "Are you sure you want to delete the \"{name}\" directory?",
	"Opravdu chcete smazat call flow \"{name}\"?": "Do you really want to delete call flow \"{name}\"?",
	"Opravdu chcete smazat kampaň \"{name}\"?": "Are you sure you want to delete the \"{name}\" campaign?",
	"Opravdu chcete smazat skupinu \"{name}\"?": "Do you really want to delete the group \"{name}\"?",
	"Opravdu chcete smazat skupinu kategorií \"{name}\"?": "Do you really want to delete the category group \"{name}\"?",
	"Opravdu chcete smazat tento uzel?": "Do you really want to delete this node?",
	"Opravdu chcete smazat časovou podmínku \"{name}\"?": "Do you really want to delete time condition \"{name}\"?",
	"Opravdu si přejete hovor zavěsit?": "Do you really want to hangup the call?",
	"Opravdu smazat aplikaci {name}?": "Are you sure you really want to delete the {name} application?",
	"Opravdu smazat filtr {name}?": "Do you really want to delete filter {name}?",
	"Opravdu smazat frontu {name}?": "Do you really want to delete queue {name}?",
	"Opravdu smazat frontu {num}?": "Do you really want to delete queue {num}?",
	"Opravdu smazat hlášku {name}?": "Do you really want to delete sound {name}?",
	"Opravdu smazat interní linku {num}?": "Do you really want to delete in {num}?",
	"Opravdu smazat kontakt {name}?": "Do you really want to delete the contact \"{name}\"?",
	"Opravdu smazat linku \"{num}\"?": "Do you really want to delete extension \"{num}\"?",
	"Opravdu smazat pauzu {name}?": "Are you sure you really want to delete the {name} pause?",
	"Opravdu smazat skupinu {name}?": "Do you really want to delete group \"{name}\"?",
	"Opravdu smazat uživatele {name}?": "Are you sure you really want to delete the user {name}?",
	"Opravdu smazat volbu {num}?": "Do you really want to delete option {num}?",
	"Opravdu smazat člena \"{num}\"?": "Do you really want to delete member \"{num}\"?",
	"Opravdu smazat číslo {num}?": "Do you really want to delete number {num}?",
	"Opravdu smazat?": "Really delete?",
	"Opustit příposlech": "Leave listening",
	"Opuštěné": "Abandoned",
	"Opuštěný": "Abandoned",
	"Originace z ústředny": "PBX origination",
	"Osobní": "Personal",
	"Osobní statistiky": "Personal statistics",
	"Ostatní": "Other",
	"Ostatní nastavení": "Other settings",
	"Ostatní uživatelé": "Other users",
	"Otevřít": "Open",
	"Otevřít v novém okně": "Open in new window",
	"Outbound": "Outbound",
	"Ovládání HW telefonu": "HW phones control",
	"Oznámení": "Notification",
	"Oznámení pro tým": "Team notification",
	"Pauza": "Pause",
	"Pauzy": "Pauses",
	"Pauzy můžete přidat výběrem z pravého sloupce": "You can add pauses by selecting from the right column",
	"Pauzy ve skupině": "Group pauses",
	"Penalta": "Penalty",
	"Permanentní člen fronty {num} neexistuje": "Permanent queue member {num} does not exist",
	"Permanentní členové": "Permanent members",
	"Phone Number": "Phone Number",
	"Pickup skupina": "Pickup group",
	"Pickup skupiny": "Pickup groups",
	"Po opuštění fronty": "After queue exit",
	"Podkategorie": "Subcategory",
	"singular|Podkategorie": "Subcategory",
	"Podpora pro připojení zařízení za NATem": "Support for contacts behind client side NAT",
	"Podržený hovor": "Call on hold",
	"Podíl": "Ratio",
	"Pohoda": "Pohoda",
	"Pokoušíte se zobrazit více jak {max} hovorů, pro jejich získání použijte export do XLSX, nebo použijte jiný filtr.": "Trying to view more than {max} calls, to get them use export to XLSX, or use another filter.",
	"Pokoušíte se zobrazit více jak {max} hovorů, pro jejich získání použijte jiný filtr.": "Trying to view more than {max} calls. Narrow down the filter/search condition.",
	"Pokračovat do fronty": "Enter into a queue",
	"Pokročilé volby": "Advanced settings",
	"Pokusů": "Attempts",
	"Položka": "Item",
	"Pondělí": "Monday",
	"Popis": "Description",
	"Popis kampaně": "Campaign description",
	"Popište krátce problém": "Briefly describe the problem",
	"Poslech a stažení nahrávek hovorů": "Review and download of call recordings",
	"Poslední fronta": "Last queue",
	"Poslední hovory": "Recent calls",
	"Poslední volaný": "Last called",
	"Posledních 30 dnů": "Last 30 days",
	"Posledních 7 dnů": "Last 7 days",
	"Potenciálně neznámý cíl {num}": "Possibly unknown target {num}",
	"Potvrdit": "Confirm",
	"Potvrdit heslo": "Confirm password",
	"Potvrzovací hláška": "Confirmation message",
	"Používat SRTP": "Use SRTP",
	"Považovat agenta jako volného ve frontě": "Consider an agent in a queue free",
	"Povolená API": "Allowed API",
	"Povolené prefixy (pokud nevyplníte, budou povolená všechna čísla)": "Allowed prefixes (if not filled, all prefixes will be allowed)",
	"Povolit administrátorem definovaná hesla linek": "Enable custom administrator defined extension passwords",
	"Povolit agentům stahování nahrávek": "Allow agents to download call recordings",
	"Povolit možnost registrace více kontkatů": "Allow registrations of multiple contacts at the same time",
	"Pozitivní uzavření": "Positive closure",
	"Pozitivní zakončení": "Positive closure",
	"Poznámka": "Note",
	"campaign-case-export|Poznámka": "Note",
	"Poznámky": "Notes",
	"Poznámky k hovoru": "Call notes",
	"Pozor": "Warning",
	"Počet dokončených případů": "Number of completed cases",
	"Počet negativních zakončení": "Number of negative closures",
	"Počet nezakončených případů": "Number incomplete cases",
	"Počet pokusů": "Number of attempts",
	"Počet pozitivních zakončení": "Number of positive closures",
	"Počet rozvolaných čísel": "Number of calls",
	"Počet volných agentů": "Number of free agents",
	"Počet zavolání": "Number of dials",
	"Počet zmeškání": "Number of misses",
	"Počet znaků": "Number of characters",
	"Počet čekajících hovorů": "Number of waiting calls",
	"Pořadí kontaktů": "Contact order",
	"Pravidelně testovat dostupnost kontaktů": "Periodically test contact reachability",
	"Priorita": "Priority",
	"Priority": "Priorities",
	"Pro dokončení registrace zadejte své telefonní číslo a nové heslo pro Váš účet: {email}.": "To complete registration, enter your phone number and a new password for your account: {email}.",
	"Pro hovor z": "For call from",
	"Probíhající hovor": "Call in progress",
	"Probíhající hovory": "Calls in progress",
	"Probíhající odposlech": "Spying in progress",
	"Probíhá": "Ongoing",
	"Probíhá aplikace nastavení...": "Configuration update is in progress...",
	"Prodloužit autopauzu": "Extend pause",
	"Prohlížeč zablokoval přístup k audio zařízení": "Browser blocked access to audio device",
	"Prohodit s probíhajícím hovorem": "Switch with call in progress",
	"Projekty": "Projects",
	"Propadlé hovory": "Non-handled calls",
	"Prosíme vyplňte formulář správně.": "Please fill the form correctly.",
	"Prosíme vyčkejte": "Please wait",
	"Provisioning": "Provisioning",
	"Práva": "Rights",
	"Práva k hovorům": "CDR access rights",
	"Prázdno": "Empty",
	"Prázdný XLSX soubor": "Empty XLSX file",
	"Průběžná hláška": "Repeated sound message",
	"Průměrná doba první reakce": "Average initial reaction time",
	"Průměrná doba uzavření": "Average closure time",
	"Průměrná délka hovoru": "Average call duration",
	"Průměrná délka vyzvánění": "Average ringing time",
	"Průměrné\nvyzvánění": "Average\nringing time",
	"Průměrné vyzvánění": "Average ringing time",
	"Průměrný\nhovor": "Average\ncall",
	"Průměrný hovor": "Average call",
	"Průměrný čekající\nčas (callback)": "Average waiting time\nfor callback",
	"Průměrně\nv IVR": "Average\nin IVR",
	"Průměrně v IVR": "Average in IVR",
	"Pátek": "Friday",
	"Píchačky": "Timecards",
	"Před pokračováním": "Before entry",
	"Před přesměrováním": "Before redirect",
	"Před ukončením hovoru": "Before call termination",
	"Před zeptáním": "Before asking",
	"Předmět": "Subject",
	"Přehled agentů, front a aktuálních hovorů": "Overview of agents, queues and current calls",
	"Přehrání selhalo": "Playback failed",
	"Přehrát": "Play",
	"Přehrát hlášku": "Play sound message",
	"Přehrávat průběžnou hlášku": "Play repeated sound message",
	"Přehrávat úvodní hlášku": "Play introductory sound message",
	"Přehrávač hlášky": "Sound message player",
	"Přehrávání nahrávky": "Play recording",
	"Přehrávání vyzváněcího tónu bylo zablokováno Vaším prohlížečem": "Ringing tone playback was blocked by your browser",
	"Přejmenovat kategorii": "Rename category",
	"Překročen limit počtu WebRTC zařízení. Použijte pro volání office panel, který máte právě otevřený v jiné záložce, či prohlížeči.": "The limit on the number of WebRTC devices has been exceeded. Use the office panel for calls, that you currently have open in another tab or browser.",
	"Přepojení": "Transfer",
	"Přepojený": "Transfered",
	"Přepojit": "Transfer",
	"Přepojit na": "Transfer to",
	"Přepojit na číslo": "Transfer to number",
	"Přepojit s odložením": "Attended transfer",
	"Přepojovaný": "Transfered",
	"Přeskočeno": "Skipped",
	"Přesměrovat hovor na jiný cíl": "Redirect call to another target",
	"Přesměrovat příposlech": "Transfer call listening",
	"Přesměrovat příposlech na číslo": "Transfer call listening to number",
	"Přesměrování se ukončuje, prosím vyčkejte...": "Call transfer is being terminated, please wait...",
	"Přetáhnout lze pouze jeden soubor": "Only one file can be redirected",
	"Přetáhnout lze pouze jednu fotografii.": "Please drag'n'drop just a single photo here.",
	"Přetáhnout sem lze pouze přesně jeden audio soubor.": "Only one audio file can be drag and dropped here.",
	"Převod textu na řeč": "Text to speech covnersion",
	"Přidat DTMF volbu": "Add DTMF menu item",
	"Přidat Kategorie": "Add Categories",
	"Přidat adresář": "Add directory",
	"Přidat aplikaci": "Add application",
	"Přidat call flow": "Add call flow",
	"Přidat další časový rozsah": "Add another time range",
	"Přidat datum": "Add date",
	"Přidat do adresáře": "Add to directory",
	"Přidat do skupiny": "Add to group",
	"Přidat hovor": "Add call",
	"Přidat kampaň": "Add campaign",
	"Přidat kontakt": "Add contact",
	"Přidat linku": "Add extension",
	"Přidat podmínku": "Add condition",
	"Přidat poznámku": "Add note",
	"Přidat poznámku k hovoru": "Add call note",
	"Přidat skupinu": "Add group",
	"Přidat skupinu kategorií": "Add category group",
	"Přidat volbu": "Add DTMF menu item",
	"Přidat záložku": "Add tab",
	"Přidat záznam": "Add entry",
	"Přidáváte do skupiny osobní frontu. Osobní fronty musí mít nastaveny vlastníka. Vyberte jednoho ze stávajícíh členů skupiny.": "You are adding a personal queue to the group. Personal queues must have an owner. Please select one of the existing group members.",
	"Přihlašovací údaje": "Login credentials",
	"Přihlašovat jako smart agent": "Join as smart agent",
	"Přihlašte se bez něj": "Log-in without",
	"Přihlásit": "Log in",
	"Přihlásit do všech front": "Join to all queues",
	"Přihlášen": "Logged in",
	"queue|Přihlášen trvale": "Subscribed permanently",
	"Přihlášen v této frontě": "Logged into this queue",
	"Přihlášení": "Login",
	"Přihlášení agenti / Všichni agenti": "Joined agents / All agents",
	"Přihlášení selhalo": "Login failed",
	"Přihlášní přes SIP": "Login via SIP",
	"Přijaté": "Accepted",
	"Připojeno": "Connected",
	"Připojená zařízení": "Connected devices",
	"Připojit headset": "Attach headset",
	"Příchod": "Arrived",
	"Příchozí": "Incoming",
	"Příchozí frontové hovory": "Incoming queue calls",
	"Příchozí hovor": "Incoming call",
	"Příchozí hovor od {contact}": "Incoming call from {contact}",
	"Příchozí hovor ve frontě {queue} od {contact}": "Incoming call in queue {queue} from {contact}",
	"Příchozí hovory": "Incoming calls",
	"Příchozí hovory - Úroveň služby": "Incoming calls - Service level",
	"Příchozí odposlech": "Incoming call listening-in",
	"Příchozí volby": "Incoming options",
	"Příchozí číslo": "Inbound number",
	"Příjemce": "Receiver",
	"Přímý": "Direct",
	"Případy vs. Hovory": "Cases vs. calls",
	"Příposlech aktivní": "Listening active",
	"Příposlech byl přesměrován": "Call listening-in was transferred",
	"Registrace dokončena": "Registration complete",
	"Registrace selhala": "Registration failed",
	"Registrované mobily": "Registered mobile phones",
	"Registrovat se": "Register",
	"Report agentů": "Agents report",
	"Report agentů - Hořovice": "Agents report - Hořovice",
	"Report agentů II": "Agents report II",
	"Report aktivit": "Activities report",
	"Report callbacků": "Callbacks report",
	"Report front": "Queue report",
	"Report front - Hořovice": "Queues report - Hořovice",
	"Report front - LKQ": "Queue report - LKQ",
	"Report hovorů podle kategorií": "Calls by category report",
	"Report kampaní": "Campaigns report",
	"Report kategorií": "Categories report",
	"Report odchozích hovorů": "Outgoing calls report",
	"Report pauz": "Pauses report",
	"Report ztracených hovorů": "Lost calls report",
	"Reporty": "Reports",
	"Reporty a statistiky kontaktního centra": "Contact center reports and statistics",
	"Reset hesla": "Reset password",
	"Reset hesla již nelze provést. Platnost odkazu vypršela.": "Password reset can no longer be performed. The link has expired.",
	"Resetovat pořadí": "Reset sort order",
	"Rozbalit vše": "Expand all",
	"Rozcestník": "Signpost",
	"Rozsahy datumů": "Date ranges",
	"Rozumím": "Roger",
	"Rozvolanost": "Numbers called",
	"Rychlost": "Speed",
	"Rychlé volby": "Speed dial",
	"SDP zpráva je prázdná": "SDP message is empty",
	"SMS": "SMS",
	"SMS brána": "SMS gate",
	"Sbalit vše": "Collapse all",
	"Sconto Wallboard": "Sconto Wallboard",
	"Scénář": "Scenario",
	"Scénáře": "Scenarios",
	"Sehhalo SIP spojení k ústředně": "SIP connection to the PBX has been established",
	"Sekund": "Seconds",
	"Selhala registrace odposlouchávacího zařízení": "Channel spy softphone registration failed",
	"Selhalo SIP spojení k ústředně (chyba dialogu)": "Failed SIP connection to PBX (dialog error)",
	"Selhalo SIP spojení, protistrana nodpověděla": "Failed SIP connection, counterparty nod",
	"Selhalo navázání datového spojení": "Failed to establish data connection",
	"Selhalo navázání datového spojení, nekompatibilní kodek": "Failed to establish data connection, incompatible codec",
	"Selhalo navázání datového spojení, protistrana nepotvrdila vyzvednutí hovoru": "Failed to establish data connection, counterparty did not acknowledge call pickup",
	"Selhalo načtení dat": "Data load failed",
	"Server je nedostupný. Momentálně nelze volat.": "Server unavailable. Currently unable to make a call.",
	"Server neposlal přihlašovací údaje k lince": "Server did not send login credentials to the extension",
	"Server odpojen": "Server disconnected",
	"Service\nlevel": "Service\nlevel",
	"Service desk ticket byl založen": "Service desk ticket created",
	"Service desk ticket je již založen": "Service desk ticket was already created",
	"Service level": "Service level",
	"Seznam hovorů": "Call list",
	"Seznamový": "List",
	"Siť": "Network",
	"Skrýt": "Hide",
	"Skrýt dialer": "Hide dialer",
	"Skrýt dialer (tónová volba)": "Hide dialer (tone dial)",
	"Skrýt statistiky skupiny": "Hide group statistics",
	"Skrýt vše": "Hide all",
	"Skupina": "Group",
	"Skupina/Fronta": "Group/Queue",
	"Skupiny": "Groups",
	"Smazaná": "Deleted",
	"Smazat": "Delete",
	"Směr": "Direction",
	"Směrovat na callflow": "Route to call flow",
	"Směrovat na frontu": "Route to queue",
	"Směrovat na linku": "Route to extension",
	"Sobota": "Saturday",
	"Soubor": "File",
	"Soubor s nahrávkou již neexistuje": "Recording file doesn't exist anymore",
	"Souhrny nastavení a změn": "Summary of configuration and change history",
	"Spojená linka": "Connected extension",
	"Spojení": "Connection",
	"Spojený": "Connected",
	"Spojovatelka": "Switchboard",
	"Spravovat headsety": "Manage headsets",
	"Správa front": "Queues management",
	"Správa odchozích kampaní": "Manage outbound campaigns",
	"Správa telefonních čísel, front a callflow": "Administration of phone numbers, queues and callflow",
	"Správa uživatelů, skupin a další nastavení systému": "Manage users, groups and other system settings",
	"Správa záložek": "Tab management",
	"Start": "Beginning",
	"Statistiky": "Statistics",
	"Statistiky hovorů": "Call statistics",
	"Statistiky skupiny": "Group statistics",
	"Stav": "Status",
	"Strategie volby agenta": "Agent selection strategy",
	"Stáhnout": "Download",
	"Stáhnout debugovací report": "Download debug report",
	"Stáhnout vybrané ({count})": "Download selected ({count})",
	"Stáhnout vzor": "Download template",
	"Stáhnout vzor XLSX": "Download XLSX template",
	"Stáhnout vše": "Download all",
	"Stále jste přihlášeni ve frontách": "You are still logged into the queues",
	"Středa": "Wednesday",
	"Superadmin": "Superadmin",
	"Supervizor panel": "Supervisor panel",
	"Surname": "Surname",
	"Světlý motiv": "Light theme",
	"Systémová": "System",
	"Tajný klíč": "Secret key",
	"Tato akce nelze vzít zpět.": "This action cannot be undone.",
	"Tato fronta již není dostupná": "This queue is no longer available",
	"Tato fronta již není v systému dostupná": "This queue is no longer available",
	"Tato linka již v seznamu je": "This extension is already in the list",
	"Tato nahrávka již v úložišti není dostupná": "This recording is no longer available in the repository",
	"Technické problémy s hovory je dobré hlásit do několika minut po skončení problematického hovoru či situace. K hlášení se automaticky připojuje záznam posledních aktivit v aplikaci a ten při pozdním hlášení již nemusí být aktuální.": "Technical issues with a call should be reported as soon as possible after the call ends, otherwise technical information that are automatically added to your report may become outdated, and will not be useful for debugging.",
	"Telefon": "Phone",
	"campaign-case-export|Telefon": "Phone",
	"Telefon 1": "Phone 1",
	"Telefon 2": "Phone 2",
	"Telefon a historie hovorů": "Phone and call history",
	"Telefonní číslo": "Phone number",
	"Telefonní číslo (vstupní)": "Phone number (inbound)",
	"Tento hovor je bez poznámek": "This call has no notes",
	"Tento hovor nemá žádné nahrávky": "This call was not recorded",
	"Tento měsíc": "This month",
	"Tento rok": "This year",
	"Tento týden": "This week",
	"Tester zákaznického API": "Customer API tester",
	"Text": "Text",
	"Text hlášky": "Message text",
	"Text je příliš dlouhý": "Text is too long",
	"Text je příliš krátký": "Text is too short",
	"Text oznámení...": "Notification text...",
	"TextToSpeech": "TextToSpeech",
	"Timeout": "Timeout",
	"Timeout (s)": "Timeout (s)",
	"Timeout vytáčení z linky": "Dial timeout",
	"Timeout vytáčení z linky (s)": "Dial timeout (s)",
	"Tmavý motiv": "Dark theme",
	"Toto pole je vyžadované": "This field is required",
	"Toto číslo již je členem fronty": "This number is already a member of a queue",
	"Tour begin date": "Tour begin date",
	"Tour end date": "Tour end date",
	"Transport": "Transport",
	"Trvale přihlášen v této frontě": "Permanently logged into this queue",
	"Trvání": "Duration",
	"Typ": "Type",
	"Tónová volba": "Tone dial",
	"Tónová volba (DTMF)": "Tone dial (DTMF)",
	"Ukončit hovor": "End call",
	"Ukončit hovor po vyžádaném callbacku": "End call after requested callback",
	"Ukončit náhrávání": "Finish recording",
	"Ukončit práci": "End work",
	"Uložit": "Save",
	"Uložit a zavřít": "Save and close",
	"Uložit a zavřít kartu hovoru": "Save and close the call card",
	"Uložit změny": "Save changes",
	"Upraveno": "Modified",
	"Upravit": "Edit",
	"Upravit DTMF volbu": "Edit DTMF menu item",
	"Upravit adresář": "Edit directory",
	"Upravit aplikaci": "Edit application",
	"Upravit call flow": "Edit call flow",
	"Upravit filtr": "Edit filter",
	"Upravit frontu": "Edit queue",
	"Upravit hlášku": "Edit sound",
	"Upravit interní linku": "Edit extension",
	"Upravit kampaň": "Edit campaign",
	"Upravit kontakt": "Edit contact",
	"Upravit linku": "Edit extension",
	"Upravit nastavení linky": "Extension settings for",
	"Upravit pauzu": "Edit pause",
	"Upravit skupinu": "Edit group",
	"Upravit skupinu kategorií": "Edit category group",
	"Upravit uživatele": "Edit user",
	"Upravit volbu": "Edit option",
	"Upravit záložku": "Edit tab",
	"Upravit záznam": "Edit entry",
	"Upravit časovou podmínku": "Edit time condition",
	"Upravit člena": "Edit member",
	"Upravit číslo": "Edit number",
	"User Agent": "User Agent",
	"Uzavřel": "Closed by",
	"Uzavřené případy": "Closed cases",
	"Uzavření případu zpětného volání (callback)": "The resolution of the callback case",
	"Uzavřít - neuspěšné": "Close - failure",
	"Uzavřít - úspěšné": "Close - success",
	"Uživatel": "User",
	"Uživatele můžete přidat výběrem z pravého sloupce": "You can add users by selecting them from the right column",
	"Uživatele můžete založit v konfiguraci uživatelů": "You can create users in the user configuration",
	"Uživatelská příručka": "User manual",
	"Uživatelé": "Users",
	"Uživatelé skupiny": "Group users",
	"V Autopauze": "Autopaused",
	"V CDR jen skupinové hovory": "Only group calls in CDR",
	"V XLSX souboru chybí sloupec {name}": "XLSX file is missing a column: {name}",
	"V hovoru": "In call",
	"V hovoru In": "In call In",
	"V hovoru Out": "In call Out",
	"V hovoru celkem": "Total in call",
	"V pauze": "Paused",
	"V pauze {name}": "Paused - {name}",
	"V pořádku": "OK",
	"V prvním řádku XLSX souboru chybí názvy sloupců: {cols}": "The first line of the XLSX file is missing column names: {cols}",
	"V prvním řádku XLSX souboru musí být názvy sloupců: Jméno, Firma, Telefon": "The first line of the XLSX file must have the column names: Name, Company, Phone",
	"V práci": "At work",
	"V rychlých kontaktech je prázdno": "You don't have any speed dial contact lists",
	"Varování": "Warning",
	"Ve frontách celkem": "In all queues",
	"Ve frontě {queue}": "In queue {queue}",
	"Ve skupině je zatím prázdno": "The group is empty for now",
	"Verze aplikace": "Application version",
	"Viditelnost dat": "Data visibility",
	"Vlastní": "Custom",
	"Vlastník": "Owner",
	"Vlastník osobní fronty": "Personal queue owner",
	"Volající": "Caller",
	"Volající a volaný": "Caller and callee",
	"Volané číslo neexistuje": "The called number does not exist",
	"Volaný": "Callee",
	"Volaný není dostupný": "Called number is not available",
	"Volaný neodpověděl": "Caller did not answer",
	"Volba": "Option",
	"Volba (0-9, *, #, +)": "Tone dial (0-9, *, #, +)",
	"Volba DTMF": "DTMF digit",
	"Volný": "Available",
	"Volných agentů": "Free agents",
	"Volných agentů / Agenti na externích linkách": "Free agents / Agents with external extension",
	"Volných {percent}": "Available {percent}",
	"Volání API selhalo": "API call has failed",
	"Voucher": "Voucher",
	"Vrátit do neaktivních": "Return to inactive",
	"Vrátit do probíhajícího hovoru": "Unhold this call",
	"Vrátit výchozí nastavení": "Revert to default settings",
	"Vstup do fronty": "Enter queue",
	"Vstupní akce": "Inbound action",
	"Vstupní fronta": "Inbound queue",
	"Vstupní číslo": "Inbound number",
	"Vyber agenta": "Select agent",
	"Vyber si frontu": "Select queue",
	"Vyberte adresář": "Select directory",
	"Vyberte call flow": "Select call flow",
	"Vyberte cílovou frontu": "Select destination queue",
	"Vyberte cílovou linku": "Select destination extension",
	"Vyberte cílové call flow": "Select destination call flow",
	"Vyberte filtr ze seznamu": "Select filter from the list",
	"Vyberte frontu": "Select a queue",
	"Vyberte frontu ze seznamu": "Select queue from the list",
	"Vyberte hlášku": "Select sound message",
	"Vyberte hlášku ze seznamu": "Select sound from the list",
	"Vyberte hodnotu": "Select value",
	"Vyberte kategorii": "Select category",
	"Vyberte kategorii vlevo": "Select category on the left",
	"Vyberte kontakt ze seznamu": "Select contact from the list",
	"Vyberte linku": "Select extension",
	"Vyberte linku ze seznamu": "Select extension from the list",
	"Vyberte linku...": "Select extension...",
	"Vyberte pauzu ze seznamu": "Select pause from the list",
	"Vyberte podkategorii": "Select subcategory",
	"Vyberte položku ze seznamu": "Select an item from the list",
	"Vyberte scénář": "Select scenario",
	"Vyberte skupinu ze seznamu": "Select a group from the list",
	"Vyberte telefonní číslo": "Select a phone number",
	"Vyberte uživatele": "Select a user",
	"Vyberte uživatele ze seznamu": "Select user from the list",
	"Vyberte volbu ze seznamu": "Select an option from the list",
	"Vyberte z voleb": "Select from the list",
	"Vyberte ze seznamu": "Select from the list",
	"Vyberte záznamník ze seznamu": "Select a mailbox from the list",
	"Vyberte časovou podmínku": "Select a time condition",
	"Vyberte číslo": "Select a number",
	"Vyberte číslo ze seznamu": "Select number from the list",
	"Vyberte...": "Select...",
	"Vybrat kategorii": "Select category",
	"Vybrat kategorii a přidat poznámku": "Select category and add a note",
	"Vybrat vše": "Select all",
	"Vybráno *{n} adresářů*": [
		"Selected *{n} directory*",
		"Selected *{n} directories*"
	],
	"Vybráno *{n} front*": [
		"Selected *{n} queue*",
		"Selected *{n} queues*"
	],
	"Vybráno *{n} komunikačních kanálů*": [
		"",
		""
	],
	"Vybráno *{n} linek*": [
		"Selected *{n} extension*",
		"Selected *{n} extensions*"
	],
	"Vybráno *{n} pauz*": [
		"Selected *{n} pause*",
		"Selected *{n} pauses*"
	],
	"Vybráno *{n} položek*": [
		"Selected *{n} item*",
		"Selected *{n} items*"
	],
	"Vybráno *{n} uživatelů*": [
		"Selected *{n} user*",
		"Selected *{n} users*"
	],
	"Vybráno *{n} záložek*": [
		"Selected *{n} tab*",
		"Selected *{n} tabs*"
	],
	"Vybráno *{n} záznamníků*": [
		"Selected *{n} mailboxe*",
		"Selected *{n} mailboxes*"
	],
	"Vybráno *{n} časových podmínek*": [
		"",
		""
	],
	"Vybráno *{n} šablon*": [
		"Selected *{n} template*",
		"Selected *{n} templates*"
	],
	"Vygenerovat nové heslo": "Generate a new password",
	"Vyhledat v časové ose...": "Search in the timeline...",
	"Vyhledat...": "Search...",
	"Vyhledejte telefonní číslo, které vás zajímá": "Search for a phone number of interest",
	"Vyhledejte telefonní číslo...": "Search a phone number...",
	"Vyhledávání...": "Searching...",
	"Vypnout mikrofon": "Turn off microphone",
	"Vypnout vyzvánění": "Turn off ringing",
	"Vytočit": "Dial",
	"Vytočit číslo": "Dial number",
	"Vytvořeno": "Created",
	"Vytvořit": "Create",
	"Vytáčení": "Dialing",
	"Vytáčený hovor": "Dialed call",
	"Vytáčím": "Dial",
	"Vytáčíte nový hovor": "You're dialing a new call",
	"Vyzvedl": "Dialed",
	"Vyzvánění": "Ringinging",
	"Vyřizuje": "Handled by",
	"Vyřídil": "Handled by",
	"Vyřízené hovory": "Completed calls",
	"Vyžadováno oprávnění administrátora ústředny": "Only PBX administrator can perform this action",
	"Vyžádaný callback": "Requested callback",
	"Vzdalené číslo": "Remote number",
	"Vzhled": "Appearance",
	"Vznikl": "First time",
	"Váš e-mail": "Your email",
	"Více": "More",
	"Více agentů": "Multiple agents",
	"Více možností": "More options",
	"Výrazné zobrazení front": "Accented queue display",
	"Výskyt": "Appearance",
	"Výsledek": "Result",
	"Výsledek hovoru": "Call result",
	"Výška hlasu": "Pitch",
	"Včera": "Yesterday",
	"Vše": "All",
	"Všechny": "All",
	"Všechny fronty": "All queues",
	"Všechny kategorie": "All categories",
	"Všechny otevřené": "Open cases",
	"Všechny případy": "All cases",
	"Všechny skupiny": "All groups",
	"Všechny uzavřené": "Closed cases",
	"Všichni": "Everyone",
	"Všichni agenti": "All agents",
	"Všichni agenti hovoří": "All agents are busy",
	"Wallboard": "Wallboard",
	"WebPhone": "WebPhone",
	"Work in progress": "Work in progress",
	"Yealink": "Yealink",
	"Zadanému filtru neodpovídá žádná fronta": "No queue matches the filter",
	"Zadanému filtru neodpovídá žádný agent": "No agent matches the filter",
	"Zadejte nové heslo pro váš účet: {email}.": "Enter a new password for your account: {email}.",
	"Zadejte telefonní číslo": "Enter a phone number",
	"Zadání kategorie": "Call category selection",
	"Zadání poznámky": "Call notes entry",
	"Zahájit práci": "Start work",
	"Zahájit příposlech": "Start listening",
	"Zakázali jste změnu audio výstupu v prohlížeči. Nelze změnit zařízení pro vyzvánění.": "You have forbidden audio device access in your browser. It's not possible to configure ringer device.",
	"Zakázané prefixy": "Forbidden prefixes",
	"Založit ticket": "Create ticket",
	"Zaparkovat": "Park",
	"Zaparkovat hovor": "Park the call",
	"Zapauzovat": "Pause",
	"Zapnout mikrofon": "Turn on microphone",
	"Zapnout neomezenou autopauzu": "Turn on unlimited auto-pause",
	"Zapnout notifikace": "Enable notifications",
	"Zapnout pauzu": "Turn on pause",
	"Zapnout vyzvánění": "Turn on ringing",
	"Zaslat odkaz": "Send link",
	"Zatím nejsou vytvořeny žádné skupiny": "No groups are created, yet",
	"Zatím nemáte žádnou skupinu kategorií": "You do not have any category groups, yet",
	"Zatím nemáte žádné rychlé volby": "You have no speed dial shortcuts, yet",
	"Zatím nemáte žádný adresář": "You have no directory yet",
	"Zavolání": "Call count",
	"Zavěsit": "Hang up",
	"Zavřít": "Close",
	"Začátek hovoru": "Start call",
	"Začátek záznamu": "Begin recording",
	"Zařízení": "Device",
	"Zdroj": "Source",
	"Zeptat se volajícího na číslo": "Ask the caller for a number",
	"Zeptat se volajícího na číslo linky": "Ask the caller for an extension",
	"Zkontrolovat": "Verify",
	"Zkontrolujte si poštu (včetně spamu) a nastavte si nové heslo pomocí odkazu ve zprávě, kterou jsme Vám zaslali.": "Check your mail (including spam) and set a new password using the link in the message we sent you.",
	"Zkopírovat do schránky": "Copy to clipboard",
	"Zkopírovat nastavení do ostatních povolených dnů": "Copy configured time ranges into other enabled days",
	"Zkrácená volba": "Shortcut",
	"Zkrácené volby": "Shortcuts",
	"Zkrácené volby (virtuální linky)": "Shortcuts (virtual extensions)",
	"Zmeškané": "Missed",
	"Zmeškané hovory": "Missed calls",
	"Zmeškané případy": "Missed cases",
	"Zmeškaný": "Missed",
	"Zmeškaný hovor": "Missed call",
	"Zmeškaný hovor ve frontě {queue} od {contact}": "Missed call in queue {queue} from {contact}",
	"Změnit heslo": "Change password",
	"Změnit kategorii": "Change category",
	"Změnit pořadí": "Change sort order",
	"Změněná": "Changed",
	"Znak '{char}' není možné odeslat v SMS zprávě": "Character '{char}' is not allowed in a SMS message",
	"Zobrazení sloupců": "Columns visibility",
	"Zobrazit": "View",
	"Zobrazit ACL": "View ACL",
	"Zobrazit Kategorie": "Show Categories",
	"Zobrazit aktivitu": "Show activity",
	"Zobrazit detail": "Show detail",
	"Zobrazit dialer": "Show dialer",
	"Zobrazit dialer (tónová volba)": "Show dialer (tone dial)",
	"Zobrazit jen poznámky": "Show notes only",
	"Zobrazit kontakty": "View contacts",
	"Zobrazit nahrávku ze záznamníku": "Show mailbox recording",
	"Zobrazit nahrávky": "Show recordings",
	"Zobrazit nahrávky agentům": "Show recordings to agents",
	"Zobrazit nahrávky callbacku": "Show callback recordings",
	"Zobrazit nahrávky ze záznamníku": "Show mailbox recordings",
	"Zobrazit názvy front": "Show queue names",
	"Zobrazit po ukončení hovoru okno pro": "When a call ends show window for",
	"Zobrazit poznámky": "Show notes",
	"Zobrazit v dialeru fronty jako projekty.": "Show queues as projects in dialer.",
	"Zobrazit v dialeru osobní fronty jako projekty.": "Show personal queues as projects in dialer.",
	"Zobrazit vše": "Show all",
	"Zobrazit čísla front": "Show queue numbers",
	"Zobrazovat přihlášené fronty jako první": "Show joined queues first",
	"Zobrazuje se pouze prvních 200 záznamů. Použijte vyhledávání či export pro práci se všemi záznamy.": "Only the first 200 records are visible. Use search to narrow down the results or export all data to XLSX.",
	"Zobrazuje se {n} z {total} záznamů. Zobrazení dalších záznamů může trvat dlouhou dobu a výrazně zpomalit prohlížeč.": "You're viewing {n} out of {total} records. Showing more records may take long time and slow down the browser.",
	"Zpráva": "Message",
	"Zpět": "Back",
	"Zrušit": "Cancel",
	"Zrušit autopauzu": "Cancel pause",
	"Zrušit filtry": "Cancel filters",
	"Zrušit odložení": "Cancel hold",
	"Zrušit pauzu": "Cancel pause",
	"Zrušit přepojení": "Cancel reconnect",
	"Zrušit vynucenou pauzu": "Cancel forced auto-pause",
	"Zrušit výběr": "Deselect all",
	"Ztratíte přístup k administraci skupiny. Pokračovat?": "You are going to lose access to this group. Continue?",
	"Zvolte výsledek hovoru": "Classify the call result",
	"Zvoní agent s nejméně hovory": "Agent with the fewest calls is ringing",
	"Zvoní jeden po druhém od posledního": "Ringing one after the other from the last",
	"Zvoní jeden po druhém od prvního": "Ringing one after the other from the first",
	"Zvoní náhodně zvolený agent": "Randomly selected agent is ringing",
	"Zvoní všichni najednou": "Ringing all at once",
	"Zvonění In": "Riging In",
	"Základní API": "Basic API",
	"Záložka": "Tab",
	"Záložky AP": "AP tabs",
	"Záložky můžete přidat výběrem z pravého sloupce": "You can add tabs by selecting them from the right column",
	"Záložky ve skupině": "Tabs in a group",
	"Záznam": "Recording",
	"Záznam nedostupný": "Record is not available",
	"Záznam není dostupný": "Recording is not available",
	"Záznamník": "Mailbox",
	"Záznamník u callbacku": "Callback mailbox",
	"Záznamník u hovoru": "Call mailbox",
	"Záznamníky": "Mailboxes",
	"Záznamníky můžete přidat výběrem z pravého sloupce": "You can add mailboxes by selecting them from the right column",
	"Záznamníky ve skupině": "Mailboxes in a group",
	"Záznamíky": "Mailboxes",
	"Zůstat ve frontách": "Stay in queues",
	"anonym": "anonymous",
	"timerange|až": "to",
	"bez omezení": "no limit",
	"dd.mm.[rrrr]": "dd.mm.[yyyy]",
	"timerange placeholder|hh": "hh",
	"info@businesscom.cz": "info@businesscom.cz",
	"timerange placeholder|mm": "mm",
	"např. +420123456798": "eg. +420123456789",
	"např. 1": "eg. 1",
	"např. 60": "eg. 60",
	"osobní": "personal",
	"www.businesscom.cz": "www.businesscom.cz",
	"zavřít": "close",
	"zobrazit zbytek": "show all",
	"{group}\nplnění": "{group}\nfullfillment",
	"{n} záznamů se importovat nepodařilo": [
		"",
		""
	],
	"Úplná historie hovorů ústředny": "Complete call history of the call center",
	"Úprava kontaktu": "Edit contact",
	"Úroveň In": "Service level In",
	"Úroveň Out": "Service level Out",
	"Úroveň služby": "Service level",
	"Úspešnost dovolání": "Pick up success rate",
	"Úspěch": "Success",
	"Úspěšné": "Success",
	"Úterý": "Tuesday",
	"Úvodní hláška": "Introductory sound message",
	"Čas": "Time",
	"Čas posledního odhlášení": "Time of last logout",
	"Čas posledního pokusu": "Time of last attempt",
	"Čas posledního volání": "Time of last call",
	"Čas prvního přihlášení": "Time of first login",
	"Čas registrace": "Time of registration",
	"Čas ukončení": "End time",
	"Čas uzavření": "Closed at",
	"Čas v IVR": "Time in IVR",
	"Čas vyřízení": "Handling time",
	"Čas zahájení": "Start time",
	"Čas založení": "Establishment time",
	"Čas zmeškaného hovoru": "Missed call time",
	"Čas záznamu": "Time of recording",
	"Časová podmínka": "Time range",
	"Časová podmínka je prázdná a nikdy se neuplatní": "Time condition is empty and will never match",
	"Časové podmínky": "Time ranges",
	"Časový slot": "Time slot",
	"campaign-case-export|Časový slot do": "Time slot until",
	"campaign-case-export|Časový slot od": "Time slot since",
	"Čekající": "Pending",
	"Čekající hovory": "Call waiting",
	"Čekající čas\nvšech příchozích\nhovorů (bez IVR)": "Waiting time\nof incoming calls\n(w/o IVR)",
	"Čekajících hovorů": "Calls waiting",
	"Člen nenalezen": "Member not found",
	"Čtvrtek": "Thursday",
	"Čísla pro odchozí identifikaci": "Outbound identification numbers",
	"Číslo": "Number",
	"Číslo (libovolné)": "Number (any)",
	"Číslo fronty": "Queue number",
	"Číslo je v adresáři": "The number is in the directory",
	"Číslo linky": "Extension number",
	"Číslo musí být vyplněno": "Number must be filled in",
	"Číslo nemá historii": "The phone number has no history",
	"Číslo odchozí identifikace {num} není v seznamu telefoních čísel": "Caller identification number {num} is not in the trunk numbers list",
	"Číslo smlouvy": "Contract number",
	"Číslo v adresáři?": "Number in a directory?",
	"čas": "time",
	"Řadit podle názvu front": "Sort by queue name",
	"Řadit podle čísla front": "Sort by queue number",
	"Šablony": "Templates",
	"Žádná": "None",
	"Žádná akce": "No action",
	"Žádná linka": "No extension",
	"Žádné audio výstupy nebyly nalezeny": "No audio outputs were found",
	"Žádné další adresáře nejsou dostupné": "No other directories are available",
	"Žádné další fronty nejsou dostupné": "No other queues are available",
	"Žádné další linky nejsou dostupné": "No other extensions are available",
	"Žádné další pauzy nejsou dostupné": "No more pauses available",
	"Žádné další záložky nejsou dostupné": "No other tabs are available",
	"Žádné další záznamníky nejsou dostupné": "No other mailboxes are available",
	"Žádné frontové hovory": "No queued calls",
	"Žádné frontové požadavky": "No queue requests",
	"Žádné fronty nejsou dostupné": "No more queues available",
	"Žádné fronty nejsou k dispozici": "No queues available",
	"Žádné headsety nejsou připojené": "No headsets are attached",
	"Žádné hovory neproběhly": "No calls have been made",
	"Žádné kampaně nejsou aktivní": "No campaigns are active",
	"Žádné kontakty": "No contacts",
	"Žádné skupiny nejsou dostupné": "No groups available",
	"Žádné tickety nebyly nalezeny": "No tickets were found",
	"Žádné výsledky": "No results",
	"Žádné zaparkované hovory": "No parked calls",
	"Žádné záznamy k dispozici": "No recordings are available",
	"Žádní další uživatelé nejsou dostupní": "No other users available",
	"Žádný aktivní hovor": "No call in progress",
	"∑ Délka hovorů": "∑ Duration of calls",
	"⌀ Délka hovoru": "⌀ Call duration",
	"⌀ Délka v IVR": "⌀ Length in IVR",
	"⌀ Délka vyzvánění": "⌀ Ringing duration",
	"⌀ Hovor In": "⌀ Call duration In",
	"⌀ Hovor Out": "⌀ Call duration Out",
	"⌀ Zvonění In": "⌀ Ringing In",
	"__plural": function(n) { return (n != 1) ? 1 : 0; },
	"__nplurals": 2
};
i18n.langs.de = {
	"Agent je přihlášen ve {n} frontách": [
		"Agent je přihlášen v {n} frontě",
		"Agent je přihlášen ve {n} frontách",
		"Agent je přihlášen v {n} frontách"
	],
	"Importováno {n} záznamů": [
		"",
		""
	],
	"Musí být telefonní číslo": "Vybrán *{n} adresář*",
	"Neexistující cílové callflow {name}": "Vybrán *{n} adresář*",
	"Service\nlevel": "Úroveň služby",
	"Service level": "Úroveň služby",
	"Telefonní číslo (vstupní)": "Vybrán *{n} adresář*",
	"Vyberte adresář": "Vybrán *{n} adresář*",
	"Vyberte call flow": "Vybrán *{n} adresář*",
	"Vyberte cílovou frontu": "Vybrán *{n} adresář*",
	"Vyberte cílovou linku": "Vybrán *{n} adresář*",
	"Vyberte cílové call flow": "Vybrán *{n} adresář*",
	"Vyberte filtr ze seznamu": "Vybrán *{n} adresář*",
	"Vyberte frontu": "Vybrán *{n} adresář*",
	"Vyberte hlášku": "Vybrán *{n} adresář*",
	"Vyberte hlášku ze seznamu": "Vybrán *{n} adresář*",
	"Vyberte linku ze seznamu": "Vybrán *{n} adresář*",
	"Vyberte linku...": "Vybrán *{n} adresář*",
	"Vyberte skupinu ze seznamu": "Vybrán *{n} adresář*",
	"Vyberte telefonní číslo": "Vybrán *{n} adresář*",
	"Vyberte uživatele": "Vybrán *{n} adresář*",
	"Vyberte volbu ze seznamu": "Vybrán *{n} adresář*",
	"Vyberte z voleb": "Vybrán *{n} adresář*",
	"Vyberte číslo": "Vybrán *{n} adresář*",
	"Vyberte číslo ze seznamu": "Vybrán *{n} adresář*",
	"Vybráno *{n} adresářů*": [
		"Vybrán *{n} adresář*",
		"Vybrány *{n} adresáře*",
		"Vybráno *{n} adresářů*"
	],
	"Vybráno *{n} front*": [
		"Vybrána *{n} fronta*",
		"Vybrány *{n} fronty*",
		"Vybráno *{n} front*"
	],
	"Vybráno *{n} komunikačních kanálů*": [
		"",
		""
	],
	"Vybráno *{n} linek*": [
		"Vybrána *{n} linka*",
		"Vybrány *{n} linky*",
		"Vybráno *{n} linek*"
	],
	"Vybráno *{n} pauz*": [
		"Vybrána *{n} pauza*",
		"Vybrány *{n} pauzy*",
		"Vybráno *{n} pauz*"
	],
	"Vybráno *{n} položek*": [
		"Vybrána *{n} položka*",
		"Vybrány *{n} položky*",
		"Vybráno *{n} položek*"
	],
	"Vybráno *{n} uživatelů*": [
		"Vybrán *{n} uživatel*",
		"Vybráni *{n} uživatelé*",
		"Vybráno *{n} uživatelů*"
	],
	"Vybráno *{n} záložek*": [
		"Vybrána *{n} položka*",
		"Vybrány *{n} položky*",
		"Vybráno *{n} položek*"
	],
	"Vybráno *{n} záznamníků*": [
		"Vybrána *{n} linka*",
		"Vybrány *{n} linky*",
		"Vybráno *{n} linek*"
	],
	"Vybráno *{n} časových podmínek*": [
		"",
		""
	],
	"Vybráno *{n} šablon*": [
		"Vybrána *{n} šablona*",
		"Vybrány *{n} šablony*",
		"Vybráno *{n} šablon*"
	],
	"Vzdalené číslo": "Vybrán *{n} adresář*",
	"{n} záznamů se importovat nepodařilo": [
		"",
		""
	],
	"__plural": function(n) { return (n != 1) ? 1 : 0; },
	"__nplurals": 2
};

for (let entries of Object.values(i18n.langs)) {
	entries.__get_plural_index = entries.__plural;
}

function _l(lang, msgid) {
	return _lc(lang, msgid);
}

function _lc(lang, msgid, context) {
	let translation = i18n.langs[lang][(typeof context != 'undefined' ? context + '|' : '') + msgid];

	return typeof translation == 'string' ? translation : msgid;
}

function _ln(lang, n, msgid) {
	return _lnc(lang, n, msgid);
}

function _lnc(lang, n, msgid, context) {
	let translation = i18n.langs[lang][(typeof context != 'undefined' ? context + '|' : '') + msgid];
	if (translation) {
		msgid = translation[i18n.langs[lang].__get_plural_index(n)] || msgid;
	}

	return msgid.replace(/{n}/, n);
}

function _(msgid) {
	return _lc(i18n.lang, msgid);
}

function _c(msgid, context) {
	return _lc(i18n.lang, msgid, context);
}

function _n(n, msgid) {
	return _lnc(i18n.lang, n, msgid);
}

function _nc(n, msgid, context) {
	return _lnc(i18n.lang, n, msgid, context);
}
